import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ScrollArea } from "@/components/ui/scroll-area";
import { SearchTermOrigin } from "@/types/search-term";

interface SearchTermOriginsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  origins: SearchTermOrigin[];
  productName: string;
}

export function SearchTermOriginsModal({
  open,
  onOpenChange,
  origins,
  productName,
}: SearchTermOriginsModalProps) {
  const sorted = [...origins].sort(
    (a, b) => b.original_phrase_search_volume - a.original_phrase_search_volume
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-card">
        <DialogHeader>
          <DialogTitle>Search Term Origins</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">
          Shows where each individual search term keyword originated from, including the original keyword phrase and its search volume.
        </p>

        <ScrollArea className="max-h-[500px]">
          <div className="pr-3">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[140px]">Search Term</TableHead>
                <TableHead>Original Keyword Phrase</TableHead>
                <TableHead className="text-right w-[160px]">
                  Original Keyword Phrase Search Volume
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sorted.map((origin, idx) => (
                <TableRow key={idx}>
                  <TableCell className="font-medium text-primary">
                    {origin.keyword}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {origin.original_phrase}
                  </TableCell>
                  <TableCell className="text-right font-medium">
                    {(origin.original_phrase_search_volume ?? 0).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </div>
        </ScrollArea>

        <div className="text-xs text-muted-foreground pt-2 border-t border-border">
          {sorted.length} unique keyword{sorted.length !== 1 ? "s" : ""} traced to their landscape origins
        </div>
      </DialogContent>
    </Dialog>
  );
}
